import { render, staticRenderFns } from "./RouterBack.vue?vue&type=template&id=7a4e6b94&scoped=true&"
import script from "./RouterBack.vue?vue&type=script&lang=js&"
export * from "./RouterBack.vue?vue&type=script&lang=js&"
import style0 from "./RouterBack.vue?vue&type=style&index=0&id=7a4e6b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e6b94",
  null
  
)

export default component.exports